import { render, staticRenderFns } from "./DecimalComponent.vue?vue&type=template&id=1803b7dc&scoped=true&"
import script from "./DecimalComponent.vue?vue&type=script&lang=js&"
export * from "./DecimalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1803b7dc",
  null
  
)

export default component.exports